import React from "react";

export const VERTICAL_NAV_OPTIONS = {
  lobby: "LOBBY",
  mainStage: "MAIN_STAGE",
  rooms: "ROOMS",
  networking: "NETWORKING",
  attendees: "ATTENDEES",
  chat: "CHAT",
  polls: "POLLS",
  qna: "QNA",
  broadcasts: "BROADCASTS",
  booth: "BOOTH",
  backstage: "BACKSTAGE",
  help: "HELP"
};

const VerticalNavBarContext = React.createContext({
  currentNavBarSelection: VERTICAL_NAV_OPTIONS.lobby,
  currentNavBarSelection: VERTICAL_NAV_OPTIONS.booth,
  setCurrentNavBarSelection: () => {},
  hasNavBarPaneOpen: false,
  setHasNavBarPaneOpen: () => {}
});

export default VerticalNavBarContext;

export const VerticalNavBarContextWrapper = ({ children }) => {
  const [currentNavBarSelection, setCurrentNavBarSelection] = React.useState(
    VERTICAL_NAV_OPTIONS.lobby,
    VERTICAL_NAV_OPTIONS.booth
  );
  const [hasNavBarPaneOpen, setHasNavBarPaneOpen] = React.useState(false);
  return (
    <VerticalNavBarContext.Provider
      value={{
        currentNavBarSelection,
        setCurrentNavBarSelection,
        hasNavBarPaneOpen,
        setHasNavBarPaneOpen
      }}
    >
      {children}
    </VerticalNavBarContext.Provider>
  );
};
